import { Envs } from 'scbk-services';
import { FundConfigTypes } from './types/fund-config-types';

export const FundConfig: FundConfigTypes = {
    xxxFeatureToggle: {
        value: 'Y',
    },

    //2026.06.24 펀드 피처플래그 추가
    FeatureFundToggle: {
        value: 'false',
        env: {
            [Envs.LOCAL]: 'true',
            [Envs.DEV]: 'true',
            [Envs.SIT]: 'false',
            [Envs.UAT]: 'false',
            [Envs.PT]: 'false',
            [Envs.OAT]: 'false',
            [Envs.STAGING]: 'false',
            [Envs.PROD]: 'false',
        },
    },
};
